import { render, staticRenderFns } from "./loader.pug?vue&type=template&id=6a17f8e6&lang=pug&external"
import script from "./loader.js?vue&type=script&lang=js&external"
export * from "./loader.js?vue&type=script&lang=js&external"
import style0 from "./loader.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a17f8e6')) {
      api.createRecord('6a17f8e6', component.options)
    } else {
      api.reload('6a17f8e6', component.options)
    }
    module.hot.accept("./loader.pug?vue&type=template&id=6a17f8e6&lang=pug&external", function () {
      api.rerender('6a17f8e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loader/index.vue"
export default component.exports